import { OrSettingsEnum, SuggestedSettingsEnum } from '@lp/features/RoutePlanner/types';
import { RouteTypeSettingsEnum, TravelTypeHosTx } from '@/api/apis/mission-planner';
import { NameByValue } from '@/types';

export const SUGGESTED_ROUTE_TYPE_NAME: Record<RouteTypeSettingsEnum, string> = {
  [RouteTypeSettingsEnum.Full]: 'Full Route',
  [RouteTypeSettingsEnum.Hub_DH]: 'Hub-DH',
  [RouteTypeSettingsEnum.Custom_DH_TXC_Hub]: 'Custom-DH-TXC-Hub',
  [RouteTypeSettingsEnum.Custom_TXC_Hub]: 'Custom-TXC-Hub',
};

export const DH_TXC_TRANSPORTATION_TYPE_NAME: Record<TravelTypeHosTx, string> = {
  [TravelTypeHosTx.Default]: 'Default',
  [TravelTypeHosTx.Drive]: 'Drive',
  [TravelTypeHosTx.Flight]: 'Flight',
};

export const OR_TIME_TYPE_NAME: Record<OrSettingsEnum, string> = {
  [OrSettingsEnum.CurrentOr]: 'Current',
  [OrSettingsEnum.OrRange]: 'Within Range',
  [OrSettingsEnum.CustomOr]: 'Custom',
};

export const OR_MAX_OFFSET_HOURS = 6;

export const CUSTOM_OR_DEFAULT_OFFSET_HOURS = 1;

export const ROUTE_TYPE_LIST_ITEMS: NameByValue[] = Object.entries(SUGGESTED_ROUTE_TYPE_NAME).map(([value, name]) => ({
  value,
  name: value === RouteTypeSettingsEnum.Full ? name : `Partial: ${name}`,
}));

export const DH_TXC_TRANSPORTATION_LIST_ITEMS: NameByValue[] = Object.entries(DH_TXC_TRANSPORTATION_TYPE_NAME).map(
  ([value, name]) => ({ value, name }),
);

export const OR_TIME_LIST_ITEMS: NameByValue[] = Object.entries(OR_TIME_TYPE_NAME).map(([value, name]) => ({
  value,
  name,
}));

export const CUSTOM_ROUTE_SETTINGS: SuggestedSettingsEnum[] = [
  SuggestedSettingsEnum.RouteType,
  SuggestedSettingsEnum.StartLocation,
  SuggestedSettingsEnum.StartTime,
  SuggestedSettingsEnum.ArrivalHub,
];
